import { SEX_TYPE } from '../constants/category';
import { IGroupPostDetail } from 'redhotpie-shared-lib/interfaces/IGroup';
import TYPE from '../constants/newFeed';
import * as utils from '../functions/utils';
import { IMainPhoto, IUserLoginInfo } from '../interfaces/IUser';
import {
  AccessibilitySettings,
  GroupUserGrants,
  IGroupBanner,
  IGroupDetail,
  IGroupMedia,
  IGroupPost,
  IJoinSettings,
  ISeekingTypeServer,
} from '../types/clubProfile';
import Group from './group';
import owner from './owner';
import Photo from './photo';
import timezone from './timezone';
import User from './user';
import eventSearch from './eventSearch';
import Owner from './owner';

export default class GroupDetail {
  hasRated: boolean;
  rateScore: number;
  hasCommented: boolean;
  events: { current: number; past: number };
  totalRateCount: number;
  detail: IGroupDetail;
  joinSettings: IJoinSettings;
  isOwner: boolean;
  owner: any;
  banner: IGroupBanner;
  accessibilitySettings: AccessibilitySettings;
  stats: any;
  userGrants: GroupUserGrants;

  constructor() {
    this.hasRated = false;
    this.rateScore = 0;
    this.hasCommented = false;
    this.events = { current: 0, past: 0 };
    this.totalRateCount = 0;
    this.detail = {} as IGroupDetail;
    this.isOwner = false;
    this.joinSettings = {} as IJoinSettings;
    this.banner = {} as IGroupBanner;
    this.accessibilitySettings = {} as AccessibilitySettings;
    this.owner = {};
    this.stats = {};
    this.userGrants = {} as GroupUserGrants;
  }

  static mappingPhoto(_obj: any) {
    const obj: any = {
      photoId: _obj.PhotoID,
      height: _obj.Height ? _obj.Height : 0,
      width: _obj.Width ? _obj.Width : 0,
      isUserImage: _obj.IsUserImage ? _obj.IsUserImage : false,
      isPublic: _obj.IsPublic ? _obj.IsPublic : false,
      classification: _obj.Classification,
      thumbUrl: _obj.ThumbUrl ? _obj.ThumbUrl : '',
      fullUrl: _obj.FullUrl ? _obj.FullUrl : '',
      showSafeMode: _obj.ShowSafeMode ? _obj.ShowSafeMode : false,
    };
    return obj;
  }
  static mappingSeekingType = (seekingTypes: ISeekingTypeServer[]) => {
    return seekingTypes.map((item: ISeekingTypeServer) => ({
      isMatch: item.IsMatch,
      value: item.Value,
      text: item.Text,
      textAbbr: item.TextAbbr,
    }));
  };

  static mappingDetailObject = (detail: any) => {
    let _detail = {} as IGroupDetail;
    _detail = {
      displayEmail: detail.DisplayEmail,
      website: detail.Website,
      description: detail.Description,
      clubID: detail.ClubID,
      clubName: detail.ClubName,
      rating: detail.Rating,
      isFeatured: detail.IsFeatured,
      isSponsored: detail.IsSponsored,
      tags: detail.Tags,
      keyWords: detail.KeyWords,
      seoUrl: detail.SEOUrl,
      location: null,
      // categories: [] as ICategory[],
      mainPhoto: {} as IMainPhoto,
      rules: detail.Rules || '',
      dateCreated: detail.DateCreated,
    };
    if (detail.SeekingInfo) {
      _detail.seekingInfo = {
        seekingAgeRange: {
          ageFrom: detail.SeekingInfo?.SeekingAgeRange?.AgeFrom || '',
          ageTo: detail.SeekingInfo?.SeekingAgeRange?.AgeTo || '',
        },
        seekingLocation: detail.SeekingInfo.SeekingLocation,
        seekingTypes: GroupDetail.mappingSeekingType(detail.SeekingInfo.SeekingTypes),
      };
    }
    if (detail.Location) {
      _detail.location = {
        city: detail.Location.City,
        state: detail.Location.State,
        stateAbbr: detail.Location.StateAbbr,
        country: detail.Location.Country,
      };
    }
    // if (detail.Categories?.length > 0) {
    //     _detail.categories = Group.mappingCategories(detail.Categories)
    // }
    if (detail.MainPhoto) {
      _detail.mainPhoto = GroupDetail.mappingPhoto(detail.MainPhoto);
    }
    return _detail;
  };

  static mappingAccessibilitySettings = (data: any) => {
    let _data = {} as AccessibilitySettings;
    if (data) {
      _data = {
        visibilityType: data.VisibilityType,
        accessibilityStatus: data.AccessibilityStatus,
      };
    }
    return _data;
  };
  static mappingStats = (data: any) => {
    let _data = {};
    if (data) {
      _data = {
        posts: data.Posts,
        albums: data.Albums,
        events: data.Events,
        photos: data.Photos,
        videos: data.Videos,
        about: 1,
        reviews: 1,
        eventsPast: data.EventsPast || 0,
      };
    }
    return _data;
  };

  static mappingUserGrants = (data: any): GroupUserGrants => {
    const _data: GroupUserGrants = {
      canAdminMembers: data.CanAdminMembers,
      canAdminValidations: data.CanAdminValidations,
      canCreateAlbums: data.CanCreateAlbums,
      canAdminEvent: data.CanAdminEvent,
      canCreatePosts: data.CanCreatePosts,
      canDeleteContent: data.CanDeleteContent,
      canDeleteGroup: data.CanDeleteGroup,
      canEditGroup: data.CanEditGroup,
      canShareGroup: data.CanShareGroup,
      showAllTabs: data.ShowAllTabs,
      upgradeOnly: data.UpgradeOnly,
      memberType: data.MemberType,
    };
    return _data;
  };

  static mappingObject(data: any) {
    let _group = Object.assign(new GroupDetail(), data);
    _group.hasRated = data.HasRated;
    _group.rateScore = data.RateScore;
    _group.hasCommented = data.HasCommented;
    _group.events = {
      current: data.Events?.Current || 0,
      past: data.Events?.Past || 0,
    };
    _group.totalRateCount = data.TotalRateCount;
    _group.isOwner = data.IsOwner;
    if (data.Detail) {
      _group.detail = GroupDetail.mappingDetailObject(data.Detail);
    }
    _group.joinSettings = data.JoinSettings ? Group.mappingJoinSetting(data.JoinSettings) : {};
    _group.banner = data.Banner ? Group.mappingBanner(data.Banner) : {};
    _group.accessibilitySettings = data.AccessibilitySettings ? GroupDetail.mappingAccessibilitySettings(data.AccessibilitySettings) : {};
    _group.owner = data.Owner ? owner.mappingObject(data.Owner) : {};
    _group.stats = data.Stats ? GroupDetail.mappingStats(data.Stats) : {};
    _group.userGrants = data.UserGrants ? GroupDetail.mappingUserGrants(data.UserGrants) : {};
    _group = utils.cleanObjectKeys(Object.keys(new GroupDetail()), _group);
    return _group;
  }

  static mappingGroupMedias = (data: any[]): IGroupMedia[] => {
    let _data: IGroupMedia[];
    _data = data.map(item => GroupDetail.mappingGroupMedia(item));
    return _data;
  };

  static mappingGroupCanInvited = (data: any[]): IGroupCanInvited[] => {
    let _data: IGroupCanInvited[];
    _data = data.map(item => ({
      clubID: item.ClubID,
      name: item.Name,
      clubBannerPhoto: {
        fullUrl: item.ClubBannerPhoto.FullUrl,
        width: item.ClubBannerPhoto.Width,
        height: item.ClubBannerPhoto.Height,
        approvalState: item.ClubBannerPhoto.ApprovalState,
      },
      memberCount: item.MemberCount,
      privacyType: item.PrivacyType,
    }));
    return _data;
  };

  static mappingGroupAlbums = (data: any[]) => {
    let _data: any[];
    _data = data.map(item => GroupDetail.mappingGroupAlbum(item));
    return _data;
  };

  static mappingGroupAlbum = (obj: any) => {
    let _obj: IGroupPost = {} as IGroupPost;
    _obj = {
      typeName: TYPE.OTG_NAME.OTG_GroupAlbum,
      isHaveSafeMode: true,
      contentItem: {
        id: obj.Album.ClubAlbumID,
        title: obj.Album.Title,
        dateCreated: obj.Album.DateCreated,
        mediaCount: obj.Album.MediaCount,
        approvalStatus: obj.Album.ApprovalState, // TODO: need to remove this one
        approvalState: obj.Album.ApprovalState,
        isMemberLike: obj.Album.CommunityAction?.IsLiked || false,
        replyCount: obj.Album.CommunityAction?.CommentCount || 0,
        likeCount: obj.Album.CommunityAction?.LikeCount || 0,
        seoURL: obj.Album.SEOUrl || '',
        media: [],
        isInteractable: obj.Album.IsInteractable,
        owner: Owner.mappingObject(obj.Album.User),
      },
    };
    if (obj.Media) {
      _obj.contentItem.media = GroupDetail.mappingGroupMedias(obj.Media);
    }
    return _obj;
  };

  static mappingGroupMedia(obj: any): IGroupMedia {
    let _obj: IGroupMedia = {} as IGroupMedia;
    _obj = {
      mediaId: obj.MediaID,
      parentId: obj.ParentID,
      parentType: obj.ParentType,
      mediaType: obj.MediaType,
      id: obj.MediaID,
      type: obj.MediaType,
      seoURL: obj.SEOUrl || obj.Photo?.SEOUrl || obj.Video?.SEOUrl || '',
      communityAction: {
        commentCount: 0,
        isLiked: false,
        likeCount: 0,
      },
      isInteractable: obj.IsInteractable || null,
    };
    if (obj.CommunityAction) {
      _obj.communityAction = {
        commentCount: obj.CommunityAction.CommentCount,
        isLiked: obj.CommunityAction.IsLiked,
        likeCount: obj.CommunityAction.LikeCount,
      };
    }
    if (obj.Photo) {
      _obj.photo = {
        id: obj.Photo.ID,
        fullUrl: obj.Photo.FullUrl,
        thumbUrl: obj.Photo.ThumbUrl,
        width: obj.Photo.Width,
        height: obj.Photo.Height,
        approvalState: obj.Photo.ApprovalState,
        imageType: obj.Photo.ImageType,
        imageActionType: obj.Photo.ImageActionType,
        showSafeMode: obj.Photo.ShowSafeMode,
      };
    }
    if (obj.Video) {
      _obj.video = {
        approvalState: obj.Video.ApprovalState,
        videoID: obj.Video.VideoID,
        videoUrl: obj.Video.VideoUrl,
        thumbUrl: obj.Video.ThumbUrl || '',
        videoType: obj.Video.VideoType || '',
        videoCode: obj.Video.VideoCode || '',
        duration: obj.Video.Duration,
        contentType: obj.Video.ContentType,
        contentLength: obj.Video.ContentLength,
        hSLVideoUrl: obj.Video.HSLVideoUrl,
        imageActionType: obj.Video.ImageActionType,
        showSafeMode: obj.Video.ShowSafeMode,
        imageType: obj.Video.ImageType,
      };
    }
    return _obj;
  }

  static mappingActivityMedia = (obj: any) => {
    let _obj: any = {};
    _obj = {
      id: obj.ID,
      type: obj.Type,
      seoURL: obj.SEOUrl || '',
      communityAction: {
        commentCount: 0,
        isLiked: false,
        likeCount: 0,
      },
      approvalStatus: obj.ApprovalStatus,
    };
    if (obj.Video) {
      _obj.video = {
        videoID: obj.Video.VideoID || '',
        videoUrl: obj.Video.VideoUrl || '',
        videoThumbUrl: obj.Video.ThumbUrl || '',
        videoCode: obj.Video.VideoCode || '',
        duration: obj.Video.Duration,
        contentLength: obj.Video.ContentLength,
        thumbUrl: obj.Video.ThumbUrl || '',
        videoType: obj.Video.VideoType || '',
      };
    }
    if (obj.Photo) {
      _obj.photo = {
        photoID: obj.Photo.PhotoID,
        fullUrl: obj.Photo.FullUrl,
        thumbUrl: obj.Photo.ThumbUrl,
        approvalStatus: obj.Photo.ApprovalStatus,
        mainPhoto: obj.Photo.MainPhoto,
        height: obj.Photo.Height,
        width: obj.Photo.Width,
        isUserImage: obj.Photo.IsUserImage,
        classification: obj.Photo.Classification,
        privateGalleryOnly: obj.Photo.PrivateGalleryOnly,
        sortOrder: obj.Photo.SortOrder,
      };
    }
    if (obj.CommunityAction) {
      _obj.communityAction = {
        commentCount: obj.CommunityAction.CommentCount,
        isLiked: obj.CommunityAction.IsLiked,
        likeCount: obj.CommunityAction.LikeCount,
      };
    }
    return _obj;
  };
  static mappingActivityMedias = (data: any[]) => {
    let _data: any[];
    _data = data.map(item => GroupDetail.mappingActivityMedia(item));
    return _data;
  };
  static mappingActivityEvent = (item: any) => {
    let _obj: any = {};
    _obj = {
      approvalStatus: item.ApprovalState,
      eventId: item.ID || 0,
      eventBannerUrl: item.ImgUrl || '',
      parentType: item.ParentType || '',
      dateHeldUtcIsoEx: item.DateHeldUtcIso || '',
      timezone: item.TimeZone ? timezone.mappingObject(item.TimeZone) : null,
      dateHeldUtcIso: item.DateHeldUtcIso
        ? utils.formatDateTimeWithTimezone(
            item.DateHeldUtcIso,
            item.timezone && utils.hasOwnProperty(item.timezone, 'ianaName') ? item.timezone.ianaName : ''
          )
        : '',
      interestCount: item.EventInterestCount || 0,
      hasExpressInterest: !!item.EventInterestExpressed,
      eventTitle: item.Title || '',
      dateHeld: item.DateHeld ? item.DateHeld : '',
      location: {
        city: item.Location || '',
        state: '',
        country: '',
        stateAbbr: '',
      },
    };
    return _obj;
  };
  static mappingGroupActivityContent = (obj: any) => {
    let _obj: any = {};
    _obj = {
      approvalState: obj.ApprovalState,
      id: obj.ID,
      dateCreated: obj.DateCreated,
      parentType: obj.ParentType,
      likeCount: obj.LikeCount,
      replyCount: obj.ReplyCount,
      mediaCount: obj.MediaCount,
      eventInterestExpressed: obj.EventInterestExpressed,
      isMemberLike: obj.IsMemberLike,
      message: obj.Message,
      classification: obj.Classification,
      title: obj.Title,
      media: [],
      owner: {},
      provider: {},
      seoURL: obj.SEOUrl || '',
      isInteractable: obj.IsInteractable,
    };
    if (obj.Media) {
      _obj.media = GroupDetail.mappingActivityMedias(obj.Media);
    }
    if (obj.Owner) {
      _obj.owner = {
        userId: obj.Owner.UserID,
        userName: obj.Owner.Username,
        memberType: obj.Owner.MemberType,
        profilePhoto: Photo.mappingObject(obj.Owner.ProfilePhoto),
      };
    }
    if (obj.Provider) {
      _obj.provider = {
        userId: obj.Provider.UserID,
        memberType: obj.Provider.MemberType,
      };
    }
    if (obj.ItemList) {
      _obj.event = obj.ItemList.map((item: any) => {
        // let guestType = Object.keys(SEX_TYPE).find(key => SEX_TYPE[key as keyof typeof SEX_TYPE] === String(item.EventGuestTypes)) || '';
        return {
          owner: owner.mappingObject(obj.Owner),
          approvalStatus: item.ApprovalState,
          eventId: item.ID || 0,
          eventBannerUrl: item.ImgUrl || '',
          parentType: item.ParentType || '',
          dateHeldUtcIsoEx: item.DateHeldUtcIso || '',
          timezone: item.TimeZone ? timezone.mappingObject(item.TimeZone) : null,
          dateHeldUtcIso: item.DateHeldUtcIso
            ? utils.formatDateTimeWithTimezone(
                item.DateHeldUtcIso,
                item.timezone && utils.hasOwnProperty(item.timezone, 'ianaName') ? item.timezone.ianaName : ''
              )
            : '',
          interestCount: item.EventInterestCount || 0,
          hasExpressInterest: !!item.EventInterestExpressed,
          isUserMatching: !!item.EventIsUserMatching,
          eventTitle: item.Title || '',
          dateHeld: item.DateHeld ? item.DateHeld : '',
          location: {
            city: item.Location,
            state: '',
            country: '',
            stateAbbr: '',
          },
          ageMin: item.EventAgeStart,
          ageMax: item.EventAgeEnd,
          // guestTypes: [
          //   {
          //     text: guestType
          //       .toLowerCase()
          //       .replace(/_/g, ' ')
          //       .replace(/\b\w/g, c => c.toUpperCase()),
          //     value: item.EventGuestTypes,
          //     isMatch: item.IsMatch,
          //   },
          // ],
          guestTypes: item.MemberTypeList ? item.MemberTypeList.map((i: any) => eventSearch.mappingObjectCategory(i)) : [],
        };
      });
    }
    return _obj;
  };

  static mappingClubAlerts = (data: any[]) => {
    let _data: IGroupNotificationLikeAndComment[];
    _data = data.map(item => GroupDetail.mappingClubAlert(item));
    return _data;
  };

  static mappingClubAlert = (obj: any) => {
    let _obj: IGroupNotificationLikeAndComment = {
      contentId: obj.ContentID,
      contentType: obj.ContentType,
      parentId: obj.ParentID,
      type: obj.Type,
      user: User.mappingObjectCustom(obj.User),
      dateCreated: obj.DateCreated,
      parentName: obj.ParentName,
      itemTotal: obj.ActivityCount || 0,
    };
    return _obj;
  };

  static mappingGroupPostDetail = (obj: any): IGroupPostDetail => {
    const { Poster, CommunityData, Media, User: UserObj, Event: EventObj } = obj;

    const owner = Poster
      ? {
          userId: Poster.ClubID,
          userName: Poster.Name,
          mainPhoto: Photo.mappingObject(Poster.ClubBannerPhoto),
          joinSettings: {
            privacyType: Poster.PrivacyType,
            joinStatus: '',
            canJoinStatus: '',
          },
          isOwner: Poster.IsOwner,
        }
      : {};

    const actor = UserObj ? User.mappingObjectCustom(UserObj) : {};
    const provider = UserObj
      ? {
          userId: UserObj.MemberID,
        }
      : {};

    const event = EventObj?.ParentType ? GroupDetail.mappingActivityEvent(EventObj) : undefined;

    return {
      typeId: TYPE.ClubPost,
      dateCreated: obj.DateCreated,
      dateEdited: obj.DateEdited,
      hasHeader: true,
      icon: 'icUserGroup',
      typeName: TYPE.ClubPost,
      entityText: '',
      actor,
      contentItem: {
        approvalState: obj.ApprovalState,
        id: obj.ClubPostID || obj.ClubAlbumID,
        dateCreated: obj.DateCreated,
        likeCount: CommunityData ? CommunityData.LikeCount : 0,
        replyCount: CommunityData ? CommunityData.CommentCount : 0,
        isMemberLike: CommunityData ? CommunityData.IsLiked : false,
        message: obj.Message,
        seoURL: obj.SEOUrl || '',
        title: undefined,
        media: Media ? GroupDetail.mappingActivityMedias(Media) : [],
        owner,
        provider,
        mediaCount: obj.MediaCount,
        isInteractable: obj.IsInteractable,
        ...(event && { event }),
      },
    } as IGroupPostDetail;
  };

  static mappingGroupChatItem = (obj: any): IGroupChatItem => {
    return {
      id: obj.id,
      roomId: obj.roomId,
      roomName: obj.roomName,
      subject: obj.subject,
      coverUrl: obj.coverUrl,
      roomJid: obj.roomJid,
      isPrivate: obj.isPrivate,
      refObjType: obj.refObjType,
      refObjId: obj.refObjId,
      refObjGroupId: obj.refObjGroupId,
      memberCount: obj.memberCount,
      isExpired: obj.isExpired,
      expiredAt: obj.expiredAt,
      isEnded: obj.isEnded,
      isActive: obj.isActive,
      ts: obj.ts,
      userDelete: obj.userDelete,
      isMatching: obj.isMatching,
    };
  };

  static mappingListGroupChatItem = (data: any[]) => {
    let _data: IGroupChatItem[];
    _data = data.map(item => GroupDetail.mappingGroupChatItem(item));
    return _data;
  };
}

export interface IGroupNotificationLikeAndComment {
  contentId: number;
  contentType: string;
  parentId: number;
  type: string;
  user: IUserLoginInfo;
  dateCreated: string;
  parentName: string;
  itemTotal: number;
}

export interface IGroupChatItem {
  id: number;
  roomId: number;
  roomName: string;
  subject: string;
  coverUrl: string;
  roomJid: string;
  isPrivate: boolean;
  refObjType: string;
  refObjId: number;
  refObjGroupId: number;
  memberCount: number;
  isExpired: boolean;
  expiredAt: string;
  isEnded: boolean;
  isActive: boolean;
  ts: string;
  userDelete: number;
  isMatching: boolean;
}

export interface IGroupCanInvited {
  clubID: number;
  name: string;
  clubBannerPhoto: {
    fullUrl: string;
    width: number;
    height: number;
    approvalState: string;
  };
  memberCount: number;
  privacyType: string;
}
